import React, { Component } from 'react';
import './button.css';
export default class Connect extends Component {
  render() {
    return (
        <a  href="#contact" style={{textDecoration:'None', fontSize:'1rem'}} className="glowing-button4">CONNECT <i class="uil uil-comment-edit"></i>
        </a>
    )
  }
}
